import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead, SITE_URL } from "@/components/SEO";
import { buildFaqJsonLd } from "@/components/FAQSection";
import { FAQS } from "@/data/faqs";

export const Route = createFileRoute("/dropshipping")({
  head: () =>
    buildHead({
      path: "/dropshipping",
      jsonLd: buildFaqJsonLd(FAQS["/dropshipping"].items),
      breadcrumbs: [
        { name: "Home", url: SITE_URL },
        { name: "Eyewear Dropshipping", url: `${SITE_URL}/dropshipping` },
      ],
    }),
  component: lazyRouteComponent(() => import("@/pages/DropshippingLanding")),
});
